import $ from 'jquery';

function shouldUpdateContent(issuer) {
  return issuer && issuer.toLowerCase().indexOf('torii') > -1;
}

function updatePortalContent(issuer) {
  if (shouldUpdateContent(issuer)) {
    addPreviewOption();
    updatePortalText();
  }
}

function addPreviewOption() {
  const $options = $('.okta-dropdown-option');
  const $preview = '<option value="oktapreview.com">oktapreview.com</option>';
  const $production = '<option value="okta.com">okta.com</option>';
  const $gov = '<option value="okta-gov.com">okta-gov.com</option>';
  const $mil = '<option value="okta.mil">okta.mil</option>';
  const $emea = '<option value="okta-emea.com">okta-emea.com</option>';
  $options.empty();
  $options.append($production);
  $options.append($emea);
  $options.append($gov);
  $options.append($mil);
  $options.append($preview);
}

function updatePortalText() {
  const $title = $('.signin-title');
  const $header = $('.signin-head');
  const $footer = $('.signin-footer');
  const $go = $('.go-btn');
  $title.html('Sign in as an Okta administrator');
  $header.remove();
  $footer.remove();
  $title.after('<p class="okta-form-footer okta-form-subtitle torii-subtitle torii-subtitle-e2e">' +
      'Enter the org subdomain where you are an administrator. ex: ' +
      '<strong>company</strong>.okta.com or <strong>dev-123</strong>.oktapreview.com</p>');
  $go.after('<div>' +
      '<p class="torii-helper-footer">Don\'t have an org? <a href="https://www.okta.com/developer/signup/">' +
      'Sign-up</a> for a free org</p>' +
      '<p class="torii-helper-footer">Contact ' +
      '<a href="mailto:developers@okta.com">developers@okta.com</a> for support</p>' +
      '</div>');
}

export default {
  shouldUpdateContent,
  updatePortalContent
};



// WEBPACK FOOTER //
// ./lib/custom-content-util.js